import { ProductPanel } from "@/components/ProductPanel";
import { SectionTitle } from "@/components/Wave";
import { ShopCard, StripsRow } from "@/components/ShopFilters";
import { ShipLine } from "@/components/ProductCard";
import { CATEGORIES, FEATURED_ID } from "@/data/shopCategories";

const PANEL_IDS = ["fish-oil", "multi"];

export const CategoryTabs = ({ active, onChange }) => (
  <div data-testid="category-tabs" role="tablist" aria-label="Shop categories" className="mt-8 flex flex-wrap gap-2 border-b-2 border-navy/10 pb-4">
    {[{ key: "", name: "All" }, ...CATEGORIES].map((c) => (
      <button key={c.key || "all"} type="button" role="tab" aria-selected={active === c.key} data-testid={`category-tab-${c.key || "all"}`} onClick={() => onChange(c.key)}
        className={`rounded-xl px-4 py-2 text-sm font-bold transition-colors ${active === c.key ? "bg-sunny text-navy" : "bg-white text-navy hover:bg-foam"}`}>
        {c.name}
      </button>
    ))}
  </div>
);

const sectionCards = (c, products) => products.filter((p) => p.category === c.name && !PANEL_IDS.includes(p.id)).length;

const CategorySection = ({ c, products, start }) => {
  const list = products.filter((p) => p.category === c.name).sort((a, b) => (b.id === FEATURED_ID) - (a.id === FEATURED_ID));
  if (!list.length) return null;
  const panels = list.filter((p) => PANEL_IDS.includes(p.id));
  const cards = list.filter((p) => !PANEL_IDS.includes(p.id));
  return (
    <section id={c.key} data-testid={`shop-section-${c.key}`} className="border-t border-navy/10 scroll-mt-28">
      <div className="container-gf pt-12"><SectionTitle chip={`${list.length} products`} title={c.name} sub={c.sub} /><ShipLine list={list} testId={`ship-line-${c.key}`} /></div>
      {panels.map((p, i) => <ProductPanel key={p.id} p={p} flip={i % 2 === 1} featured={p.id === FEATURED_ID} badge />)}
      {cards.length > 0 && (
        <div className="container-gf pb-12 pt-4">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">{cards.map((p, i) => <ShopCard key={p.id} p={p} eager={start + i < 4} />)}</div>
        </div>
      )}
    </section>
  );
};

export const CategoryView = ({ products, active }) => {
  const cats = active ? CATEGORIES.filter((c) => c.key === active) : CATEGORIES;
  let start = 0;
  return cats.map((c) => {
    const s = start;
    start += sectionCards(c, products);
    return (
    <div key={c.key}>
      <CategorySection c={c} products={products} start={s} />
      {c.key === "everyday-health" && <StripsRow products={products} />}
    </div>
    );
  });
};
